// extracted by mini-css-extract-plugin
module.exports = {"page":"Layout_page__zm6WG","pageTransition":"Layout_pageTransition__nUFhy","pageVisible":"Layout_pageVisible__W14Ko"};